/**
 * API工具类 - 提供接口路径映射功能
 */

/**
 * 获取当前选择的主体类型
 * @returns {string} 主体类型 ('1' 或 '2')
 */
export function getCurrentEntity() {
    // 优先从session获取主体信息，如果没有则从localStorage获取用户之前的选择
    const entityType = sessionStorage.getItem("ENTITY_TYPE");
    if (!entityType) {
        // 获取缓存中的主体信息
        const savedEntity = localStorage.getItem("USER_ENTITY_PREFERENCE");
        console.log("获取缓存中的主体：",savedEntity);
        if (savedEntity) {
            sessionStorage.setItem("ENTITY_TYPE", savedEntity);
            setApiPrefix(savedEntity);
            return savedEntity;
        } else {
            // 如果都没有，使用默认值"1"（股份）
            sessionStorage.setItem("ENTITY_TYPE", "1");
            setApiPrefix("1");
            return "1";
        }
    }
    setApiPrefix(entityType);
    return entityType;
}

/**
 * 获取当前API前缀
 * @returns {string} API前缀 ('/api/' 或 '/sg-api/')
 */
export function getApiPrefix() {
    return sessionStorage.getItem("API_PREFIX");
}

/**
 * 根据主体设置API前缀
 * @param {string} entity 主体类型 ('1' 或 '2')
 */
export function setApiPrefix(entity) {
    if (entity === "1") {
        sessionStorage.setItem("API_PREFIX", "/api/");
    } else if (entity === "2") {
        sessionStorage.setItem("API_PREFIX", "/sg-api/");
    }
}

/**
 * 检查是否为不需要拦截的接口（这些接口只需要只需要调用股份后端服务）
 * @param {string} url 接口URL
 * @returns {boolean} 是否为不需要拦截的接口
 */
export function isNoInterceptedApi(url) {
    const apis = [
        '/api/elineFunction/getAllFunctionByLoginUser'
    ];

    return apis.some(api => url.includes(api));
}

/**
 * 清理主体相关状态
 */
export function clearEntityStatus() {
    sessionStorage.setItem("ENTITY_TYPE", "");
    sessionStorage.setItem("API_PREFIX", "");
}
